import Page from './page';
import { trackPage } from './analytics-helper';

const fireImpressionFptiForChatLoadError = (link = '', hpid = '', pageName) => {
  // Adding pageName for asyncChat error, when async failed to load
  const errorPageId = pageName || Page.getFptiIdForChatLoadError();
  if (errorPageId) {
    const options = {
      id: errorPageId,
    };

    if (link) {
      options.link = link;
    }

    if (hpid) {
      options.hpid = hpid;
    }
    trackPage(options);
    return true;
  }
  return false;
};

export default fireImpressionFptiForChatLoadError;
